<template>
  <div>
    <v-divider class="mt-5 mb-10" />

    <div class="text-center">
      <h1 class="mt-8 mb-2 mx-auto">
        {{ $t('onboarding.payment.creditCard.withCreditCard') }}
      </h1>

      <p class="mw-300 mx-auto mb-10">
        {{ $t('onboarding.payment.creditCard.description') }}
      </p>
    </div>
    <v-form ref="form" @submit.prevent="validate" lazy-validation>
      <v-text-field
        v-model="holder_name"
        :rules="[rules.name]"
        :label="$t('onboarding.card.name')"
        :hint="$t('onboarding.card.nameHint')"
        type="text"
        outlined
      />

      <v-text-field
        v-model="number"
        v-mask="'#### #### #### ####'"
        :rules="[rules.number]"
        :label="$t('onboarding.card.number')"
        :hint="$t('onboarding.card.numberHint')"
        type="tel"
        outlined
      />

      <v-row>
        <v-col class="pt-0" cols="8" sm="6">
          <v-text-field
            v-model="expire"
            v-mask="'##/####'"
            :rules="[rules.expiredYearValidation, rules.expiredMonthValidation]"
            :label="$t('onboarding.card.dueDate')"
            :hint="$t('onboarding.card.dueDateHint')"
            hide-details="auto"
            type="tel"
            outlined
          />
        </v-col>
        <v-col class="pt-0" cols="4" sm="6">
          <v-text-field
            v-model="ccv"
            v-mask="'####'"
            :rules="[rules.ccv]"
            :label="$t('onboarding.card.ccv')"
            :hint="$t('onboarding.card.ccvHint')"
            hide-details="auto"
            type="tel"
            outlined
          />
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col cols="12" sm="6">
          <v-btn
            @click="setOnboardingStepsNavigation(4)"
            :block="$vuetify.breakpoint.xsOnly"
            elevation="0"
            large
          >
            <v-icon left small> mdi-chevron-left </v-icon>
            {{ $t('onboarding.actions.previous') }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn
            :loading="isLoading"
            :block="$vuetify.breakpoint.xsOnly"
            color="primary"
            elevation="0"
            type="submit"
            large
          >
            {{ $t('onboarding.actions.addCredit') }}
            <v-icon right small> mdi-chevron-right </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import {
  name,
  required,
  expiredMonthValidation,
  expiredYearValidation,
} from '@/util/errorHandling'

export default {
  name: 'OnboardingCreditCard',

  data() {
    return {
      holder_name: '',
      number: '',
      expire: '',
      ccv: '',
      rules: {
        name,
        required,
        expiredMonthValidation,
        expiredYearValidation,
        number: (val) => val.length >= 19 || this.$t('rules.required'),
        expire: (val) => val.length >= 7 || this.$t('rules.required'),
        ccv: (val) => val.length >= 3 || this.$t('rules.required'),
      },
    }
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'onboardingProfile',
      'onboardingServicesAndTotal',
      'onboardingAppointmentValue',
    ]),
  },

  methods: {
    ...mapActions(['showErrorMessage']),
    ...mapMutations([
      'setIsLoading',
      'setOnboardingProfile',
      'setOnboardingStepsNavigation',
    ]),

    validate() {
      if (this.$refs.form.validate()) {
        this.setIsLoading(true)

        Promise.resolve(localStorage.getItem('access_token'))
          .then((response) => {
            return JSON.parse(atob(response.split('.')[1]))
          })
          .then((response) => {
            api
              .get('/web/user/current')
              .then(({ data }) => {
                this.setOnboardingProfile({ name: data.name })

                const ccPayload = {
                  value: this.onboardingAppointmentValue,
                  type: 'ASAAS_CREDIT_CARD',
                  credit_card: {
                    info: {
                      holder_name: this.holder_name,
                      number: this.number.replace(/\D/g, ''),
                      expiry_month: this.expire.split('/')[0],
                      expiry_year: this.expire.split('/')[1],
                      ccv: this.ccv,
                    },
                    holder: {
                      name: data?.name,
                      email: response.user_name,
                      cpf_cnpj: data?.cpf,
                      postal_code: this.onboardingProfile.postalCode,
                      phone: data?.phone,
                      address_number: this.onboardingProfile.streetNumber
                        ? this.onboardingProfile.streetNumber
                        : 'S/N',
                    },
                  },
                }

                return ccPayload
              })
              .then((response) => {
                api
                  .post('/web/recharge/request', response)
                  .then(({ status }) => {
                    if (status === 200) {
                      api
                        .post('web/customerOnboarding/setNoServiceStatus')
                        .then(() => this.setOnboardingStepsNavigation(9))
                        .catch(({ data }) => {
                          data?.errors && data?.errors?.length >= 1
                            ? this.showErrorMessage(data.errors[0].message)
                            : this.showErrorMessage(data.message)
                        })
                    }
                  })
                  .catch(({ data }) => {
                    data?.errors && data?.errors?.length >= 1
                      ? this.showErrorMessage(data.errors[0].message)
                      : this.showErrorMessage(data.message)
                  })
                  .finally(() => this.setIsLoading(false))
              })
              .catch(({ data }) => {
                data?.errors && data?.errors?.length >= 1
                  ? this.showErrorMessage(data.errors[0].message)
                  : this.showErrorMessage(data.message)
              })
          })
      }
    },
  },
}
</script>
